/**
 * Le profil de soirées d'un compte, tel que le serveur le tient : points,
 * soirées résumées, badges, boutique — et une éventuelle sanction de la
 * régie. Un petit magasin hors de React, lu par « Moi », la boutique, la
 * pastille des points et le moaï (ce qu'il porte).
 */
import { useEffect, useState } from "react";

export interface SoireeCompte {
  id: string;
  titre: string;
  rdvAt: number;
  lieu: string;
  secteurId: string;
  personnes: number;
  reunis: boolean;
  createur: boolean;
  gain: number;
}

export interface Badge {
  id: string;
  nom: string;
  symbole: string;
  obtenu: boolean;
  progres: string | null;
}

export interface Article {
  id: string;
  rayon: "hoa" | "profil" | "skins" | "musique";
  nom: string;
  prix: number;
}

export interface Profil {
  points: number;
  soirees: SoireeCompte[];
  badges: Badge[];
  possessions: string[];
  porte: { hoa: string };
  articles: Article[];
}

export interface Sanction {
  type: "avertir" | "suspendre" | "bannir";
  motif: string;
  jusqua: number | null;
  a: number;
  contestee: boolean;
}

let profil: Profil | null = null;
let sanction: Sanction | null = null;
const abonnes = new Set<() => void>();
const prevenir = (): void => {
  for (const f of abonnes) f();
};

export function poserProfil(p: Profil | null, s: Sanction | null): void {
  profil = p;
  sanction = s;
  prevenir();
}

export function profilCourant(): Profil | null {
  return profil;
}

export function sanctionCourante(): Sanction | null {
  return sanction;
}

export function useProfil(): { profil: Profil | null; sanction: Sanction | null } {
  const [v, setV] = useState({ profil, sanction });
  useEffect(() => {
    const f = (): void => setV({ profil, sanction });
    abonnes.add(f);
    f();
    return () => {
      abonnes.delete(f);
    };
  }, []);
  return v;
}

/** L'accessoire que porte le moaï : celui du compte, rien sans compte. */
export function useAccessoire(): string | null {
  const { profil: p } = useProfil();
  const a = p?.porte.hoa ?? null;
  return a && a !== "hoa-classique" ? a : null;
}
